import Cookies from "js-cookie";
import {
  requestFcmToken,
  setupForegroundPushListener,
} from "../../firebase.js";
import {
  hasAnyPushPref,
  mergeSessionUserPartial,
} from "../../shared/utils/pushHealth";

export function getStoredSessionUserId() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null")?._id ?? null;
  } catch {
    return null;
  }
}

/**
 * On login, bind the browser push token to the active account.
 * Clears a stale token when the signed-in user changes.
 */
export async function reassociatePushTokenOnLogin(
  userData,
  previousUserId = null,
) {
  const nextUserId = userData?._id;
  const switchedAccount =
    previousUserId &&
    nextUserId &&
    String(previousUserId) !== String(nextUserId);

  if (switchedAccount) {
    Cookies.remove("fcmToken");
  }

  if (!hasAnyPushPref(userData)) {
    return;
  }

  if (typeof Notification === "undefined") {
    return;
  }

  if (Notification.permission !== "granted") {
    return;
  }

  setupForegroundPushListener();
  try {
    const token = await requestFcmToken(undefined, { forceUpdate: true });
    if (token && nextUserId) {
      mergeSessionUserPartial({
        _id: nextUserId,
        fcmTokenCount: Math.max(Number(userData.fcmTokenCount) || 0, 1),
      });
    }
  } catch (error) {
    console.error("Push token reassociation on login failed:", error);
  }
}

/**
 * Silently refresh the FCM token when permission is already granted.
 * Never re-prompts when permission is default/denied (UI CTAs handle that).
 */
export async function requestPushNotificationIfNeeded(userData) {
  await reassociatePushTokenOnLogin(userData, null);
}
